import { createSelector } from 'reselect';
import { getState } from 'store/utils';

export const getLoadingScriptStore = createSelector(getState, (state) => state.loadingScript);

export const getSQLScript = createSelector(getLoadingScriptStore, (state) => state.SQLScript);
export const getPagesScript = createSelector(getLoadingScriptStore, (state) => state.pagesScript);
export const getActivePageScript = createSelector(getLoadingScriptStore, (state) => state.activePageScript);
export const getSQLActivePageScript = createSelector([getPagesScript, getActivePageScript], (pages, activePage) =>
  pages.find((page) => page.page === activePage),
);

export const getSourceTables = createSelector(getLoadingScriptStore, (state) => state.sourceTables);
